import { IPromoPopup } from './promoPopup';
import { IPromoProp } from './promoProp';
import { EPromoType } from './promoType';

export interface IPromo {
  description?: string;
  labels: IPromoLabel[];
  newbuildingIds: number[];
  name: string;
  promoProps: IPromoProp[];
  promoType: EPromoType;
  popup: IPromoPopup;
  providerId: number;
  providerLogo: string;
  providerName: string;
  providerPromoId: number;
  uniqueId: string;
}

export interface IPromoLabel {
  text: string;
  type: ELabelType;
}

export enum ELabelType {
  Mortgage = 'mortgage',
  Discount = 'discount',
  Bonus = 'bonus',
  NewbuildingCount = 'newbuildingCount',
  Sale = 'sale',
  Installment = 'installment',
  NoOverpayments = 'noOverpayments',
}
